import { LitEntity, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import './assign-installer-modal';

class AssignInstallerButton extends LitEntity {
  static get properties() {
    return {
      showModal: { type: Boolean },
    };
  }

  static get styles() {
    return sharedStyles;
  }

  render() {
    return html`
      <button class="button button--contained" @click="${this._onClick}">Assign</button>
      <assign-installer-modal
        .href="${this.href}"
        ?hide="${!this.showModal}"
        @close="${() => this.showModal = false}"
        @response="${({ detail }) => this.dispatchEvent(new CustomEvent('response', { detail, bubbles: true, composed: true }))}"
      ></assign-installer-modal>
    `;
  }

  _onClick(e) {
    e.stopPropagation();
    this.showModal = true;
  }
}

window.customElements.define('assign-installer-button', AssignInstallerButton);
